import { useDispatch, useStore } from 'react-redux';
import { useApolloClient, useSubscription } from '@apollo/client';
import { getCorrelations } from '../reducers';
import { cleanCorrelations } from '../actions/correlations';
import { createOnErrorHandler } from '../components/errors/Errors';
import { createLogger } from '../utils/logging';

const logger = createLogger('useExtendedSubscription');

export const createOnSubscriptionHandler = (options, errorHandler, store, dispatch) => ({ subscriptionData: { error, data: generalChangeData } }) => {
    if (error) {
        logger.error(error);
        errorHandler(error);
    } else {
        const changeData = generalChangeData[options.dataProperty];
        const { correlationId, action: subscriptionAction } = changeData;
        logger.debug(`Received subscription action: ${subscriptionAction}`);
        const correlations = getCorrelations(store.getState());
        const existingCorrelation = correlations.find((correlation) => correlation.id === correlationId);
        if (existingCorrelation) {
            logger.debug('Processing own action...');
            dispatch(cleanCorrelations());
            if (options.refetchOnOwnResponse) {
                options.refetch && options.refetch(options.refetchVariables);
            }
        } else {
            logger.debug('Processing thirdparty action...');
            options.onChangeCallback && options.onChangeCallback(changeData);
            options.refetch && options.refetch(options.refetchVariables);
        }
    }
};

function useExtendedSubscription(subscription, options) {
    const store = useStore();
    const dispatch = useDispatch();
    const apolloClient = useApolloClient();
    const errorHandler = createOnErrorHandler(dispatch, apolloClient);

    useSubscription(subscription, {
        variables: options.variables,
        shouldResubscribe: false,
        onSubscriptionData: createOnSubscriptionHandler(options, errorHandler, store, dispatch),
    });
}

export default useExtendedSubscription;
